module.exports = __webpack_public_path__ + "img/sq_record_img3.b48189bd.png";